export { default } from './InfoButton'
